module.exports = __webpack_public_path__ + "static/UNITY-Square-One-5th-floor-traditional_v2-1b82763c6a0e266bd1f5fa602417d57a.pdf";